// extracted by mini-css-extract-plugin
export default {"multiLinkBlocksGrid":"MultiLinkBlocks_multiLinkBlocksGrid__E5T7j","card":"MultiLinkBlocks_card__OAcMt"};